import { getAPIBffBase } from "../utils";
import {
  DEFAULT_FAVORITE_SETUPS_RESPONSE,
  DEFAULT_SCHEMA,
  DEFAULT_SETUPS_RESPONSE,
} from "../pages/LandingPage/constants";
import { getAccessToken } from "./authService";
import {
  JsonSchema,
  SetupBaseRequestInfo,
  CdcmResponse,
  ReadRecordRequest,
} from "../types";

const cdcmApiUrl = getAPIBffBase();

export const getAllSetupListInfo = async (
  request: SetupBaseRequestInfo,
): Promise<CdcmResponse> => {
  try {
    const baseUrl = `${cdcmApiUrl}functionalUnit/get/setups/all`;

    const queryParams = new URLSearchParams({
      stores: request.stores ?? "",
    });
    const url = `${baseUrl}?${queryParams.toString()}`;
    const response: CdcmResponse = await fetch(url, {
      method: "GET",
      headers: {
        "x-enterprise-id": request.enterpriseId,
        "x-store-id": request.storeId,
        "x-department-name": request.accountName,
        "x-department-id": request.departmentId ?? "",
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }).then((res) => res.json());
    return response;
  } catch (error) {
    console.error(error);
    return DEFAULT_SETUPS_RESPONSE;
  }
};

export const getFavoriteSetupsList = async (
  request: SetupBaseRequestInfo,
): Promise<CdcmResponse> => {
  try {
    const url = `${cdcmApiUrl}functionalUnit/get/favourite-setups`;
    const response: CdcmResponse = await fetch(url, {
      method: "GET",
      headers: {
        "x-enterprise-id": request.enterpriseId,
        "x-store-id": request.storeId,
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }).then((res) => res.json());
    return response;
  } catch (error) {
    console.error(error);
    return DEFAULT_FAVORITE_SETUPS_RESPONSE;
  }
};

export const getSchemaBySetup = async (
  request: ReadRecordRequest,
): Promise<JsonSchema> => {
  try {
    const url = `${cdcmApiUrl}functionalUnit/schema/${request.functionalUnitName}`;

    const response: CdcmResponse = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }).then((res) => res.json());
    if (response.resultCode.includes("200") && response.resultObj !== null) {
      const schema: JsonSchema = JSON.parse(response.resultObj as string);
      return schema;
    }
    console.error(response.resultObj);
    return DEFAULT_SCHEMA();
  } catch (error) {
    console.error(error);
    return DEFAULT_SCHEMA();
  }
};

export const getSchemaBySetupForService = async (
  request: ReadRecordRequest,
): Promise<JsonSchema> => {
  try {
    const url = `${cdcmApiUrl}functionalUnit/schema/${request.functionalUnitName}`;

    const response: CdcmResponse = await fetch(url, {
      method: "GET",
      headers: {
        "x-enterprise-id": request.enterpriseId,
        "x-store-id": request.storeId,
        "x-department-name": request.accountName,
        "x-department-id": request.departmentId ?? "",
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }).then((res) => res.json());
    if (response.resultCode.includes("200") && response.resultObj !== null) {
      const schema: JsonSchema = JSON.parse(response.resultObj as string);
      return schema;
    }
    console.error(response.resultObj);
    return DEFAULT_SCHEMA();
  } catch (error) {
    console.error(error);
    return DEFAULT_SCHEMA();
  }
};

export const getSchemaBySetupForParts = async (
  request: ReadRecordRequest,
): Promise<JsonSchema> => {
  try {
    const url = `${cdcmApiUrl}functionalUnit/schema/${request.functionalUnitName}`;

    const response: CdcmResponse = await fetch(url, {
      method: "GET",
      headers: {
        "x-enterprise-id": request.enterpriseId,
        "x-store-id": request.storeId,
        "x-department-name": request.accountName,
        "x-department-id": request.departmentId ?? "",
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }).then((res) => res.json());
    if (response.resultCode.includes("200") && response.resultObj !== null) {
      const schema: JsonSchema = JSON.parse(response.resultObj as string);
      return schema;
    }
    console.error(response.resultObj);
    return DEFAULT_SCHEMA();
  } catch (error) {
    console.error(error);
    return DEFAULT_SCHEMA();
  }
};
